import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { default as ecs } from './ecs/reducers';
import experiments from './experiment/reducers';
import i18n from './i18n/reducers/i18n';
import { error, forms, modals, toast, welcomeMat } from './common/reducers';

export default combineReducers({
  routing: routerReducer,
  ecs,
  experiments,
  error,
  forms,
  modals,
  toast,
  welcomeMat,
  i18n
});
